<script>
    import httpService from '@/services/core/http.service';
    import { DxAutocomplete } from 'devextreme-vue/autocomplete';

    export default {
        props: {
            company: Object
        },
        emits: ['update:company'],
        components: {
            DxAutocomplete
        },
        data() {
            return {
                autocompleteModel: null,
                dataSource: httpService.getDxDataSource('companies/operators', 'operator')
            };
        },
        methods: {
            onSelected({ selectedItem }) {
                const value = selectedItem ? selectedItem.id : null;
                this.$emit('update:company', {
                    ...this.company,
                    wellDatabaseOperator: value
                });
            }
        }
    };
</script>

<template>
    <DxAutocomplete
        v-model="autocompleteModel"
        :data-source="dataSource"
        value-expr="operator"
        placeholder="Type operator name..."
        item-template="autocompleteTemp"
        :maxItemCount="500"
        :onSelectionChanged="onSelected"
    >
        <template #autocompleteTemp="{ data }">
            <span>{{ data.operator }}</span>
        </template>
    </DxAutocomplete>
</template>
